import { System } from '@app/core/resources/system';
import { Transaction } from './transaction';
import TransactionAmountCalculator from './transaction-amount-calculator';
import { FormatDecimalsHelper } from '@app/core/helpers/format-decimals-helper';
import { Network } from '@app/core/resources/networks';

export default class NetworkHelper {
    public constructor(public transaction: Transaction) {}

    public setTransaction(transaction: Transaction): this {
        this.transaction = transaction;

        return this;
    }

    public calculateAmount2ByNetwork(networkId: string): void {
        let transactionAmountCalculator: TransactionAmountCalculator = new TransactionAmountCalculator();

        this.transaction.attributes.account_network2 = networkId;
        this.transaction.attributes.__operation = 'receive';
        this.transaction.attributes.amount2 = transactionAmountCalculator
            .setSystem1(this.transaction.relationships.system1.data ?? new System())
            .setSystem2(this.transaction.relationships.system2.data ?? new System())
            .setNetworkId(networkId)
            .setAmount(this.transaction.attributes.amount1)
            .calculateAmount(2);
    }

    public changeAccountNetwork2(networkId: string): void {
        this.transaction.attributes.account_network2 = networkId;
    }

    public getFeeByNetwork(networkId: string): string {
        if (this.transaction.relationships.system2.data?.id === '') {
            return '0.00';
        }

        let currencyPrice: number = this.transaction.relationships.system2.data?.relationships.currency.data?.attributes.price ?? 0;
        let feeByNetwork: number =
            this.transaction.relationships.system2.data?.relationships.networks.data.find((network: Network) => network.id === networkId)
                ?.attributes.fixed_fee_usd ?? 0;

        let fee: number = feeByNetwork * currencyPrice;

        return new FormatDecimalsHelper().formatDecimal(fee, this.transaction.relationships.system2.data?.attributes.decimal_places ?? 0);
    }

    public getFeeNetworkBySystem(networkId: string, system: System): string {
        if (system.id === '') {
            return '0.00';
        }

        let currencyPrice: number = system.relationships.currency.data?.attributes.price ?? 0;
        let feeByNetwork: number =
            system.relationships.networks.data.find((network: Network) => network.id === networkId)?.attributes.fixed_fee_usd ?? 0;

        let fee: number = feeByNetwork * currencyPrice;

        return new FormatDecimalsHelper().formatDecimal(fee, system.attributes.decimal_places ?? 0);
    }
}
